import * as React from 'react';

import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import retail from '../../graphics/retail.jpg'

const trueLogoUrl = `${process.env.PUBLIC_URL}/imagotipo-blanco.svg`;

// TRUE brand tokens shared by the pre-login / onboarding pages.
export const TRUE_DARK = '#14252C';
export const TRUE_MUTED = '#6F8994';

export const primaryButtonSx = {
  bgcolor: TRUE_DARK,
  color: 'white',
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.95rem',
  py: 1.25,
  borderRadius: '8px',
  fontFamily: 'Inter, sans-serif',
  boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
  '&:hover': { bgcolor: '#1e3540' },
} as const;

export const mutedLinkStyle: React.CSSProperties = { color: TRUE_MUTED, fontSize: '0.8rem', textDecoration: 'none' };
export const strongLinkStyle: React.CSSProperties = { color: TRUE_DARK, fontWeight: 600, textDecoration: 'none' };

interface AuthLayoutProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
}

const AuthLayout = ({ title, subtitle, children }: AuthLayoutProps) => (
  <>
    <CssBaseline />
    <Grid container component="main" sx={{ height: '100vh' }}>
      {/* Left panel — dark brand + photo */}
      <Grid
        item xs={false} sm={4} md={7}
        sx={{
          position: 'relative',
          backgroundImage: `url(${retail})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(135deg, rgba(10,20,25,0.75) 0%, rgba(13,27,42,0.65) 100%)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1, p: 4, display: { xs: 'none', sm: 'flex' }, alignItems: 'flex-start' }}>
          <img src={trueLogoUrl} alt="TRUE" width={160} style={{ display: 'block', height: 'auto', opacity: 0.95, pointerEvents: 'none' }} />
        </Box>
      </Grid>

      {/* Right panel — content */}
      <Grid
        item xs={12} sm={8} md={5}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#fff' }}
      >
        <Box sx={{ width: '100%', maxWidth: 400, px: 4 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, color: TRUE_DARK, mb: 0.5, fontFamily: 'Inter, sans-serif' }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" sx={{ color: TRUE_MUTED, mb: 4, fontFamily: 'Inter, sans-serif' }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </Box>
      </Grid>
    </Grid>
  </>
);

export default AuthLayout;
